export default {
  PleaseSelectUser: '请选择客户',
  OnlyCrossBorder: '只查看跨境链路',
  CrossBorderLink: '跨境链路',
  CrossBorderNode: '跨境节点',
  NetTips:
    '您可在列表对单个网关进行快捷组网管理，图形模式支持批量修改。\n特别提醒：关闭组网功能，将可能影响关联的策略，导致策略、配置失效 ，请谨慎操作！ 如有疑问，可先咨询我司运维工程师再进行操作。',
  DirectPOP: '直连POP',
  CPEInformation: 'CPE信息',
  name: '名称',
  model: '型号',
  peerGateway: '对端网关',
  NetworkDetail: '组网详情',
  nodePlaceholder: '点击查看CPE及POP信息',
  WhetherToUse: '是否使用',
  NoneCpeIPTips: '（因配置dhcp/pppoe无法获取）',
  LocalCPE: '本端CPE',
  DirectlyConnectedNode: '直连节点',
  NodeIp: '节点IP',
  PeerCPE: '对端CPE',
}